import React, { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { toast } from "sonner";
import { api, downloadFile, formatApiError } from "../lib/api";
import { PageHeader, Panel } from "../lib/ui";
import { Button } from "../components/ui/button";
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, Cell,
} from "recharts";

export default function Reports() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/dashboard").then((r) => setData(r.data)); }, []);
  const cards = data?.cards || {};

  const doExport = async (path, params, filename) => {
    try { await downloadFile(path, params, filename); toast.success("Laporan diunduh"); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail) || "Gagal mengunduh"); }
  };

  const qcData = [
    { name: "Passed", value: cards.qc_passed || 0, color: "#22C55E" },
    { name: "Rework", value: cards.rework || 0, color: "#F97316" },
    { name: "Reject", value: cards.reject || 0, color: "#EF4444" },
    { name: "Menunggu", value: cards.waiting_qc || 0, color: "#94A3B8" },
  ];

  return (
    <div data-testid="reports-page">
      <PageHeader title="Laporan" subtitle="Ringkasan QC & stok">
        <Button variant="outline" onClick={() => doExport("/qc/export", {}, "laporan-qc.xlsx")} className="border-taupe text-cocoa" data-testid="export-qc-btn">
          <Download className="w-4 h-4 mr-1.5" /> Laporan QC
        </Button>
        <Button variant="outline" onClick={() => doExport("/qc/export", { only_reject: true }, "laporan-reject.xlsx")} className="border-taupe text-cocoa" data-testid="export-reject-btn">
          <Download className="w-4 h-4 mr-1.5" /> Barang Reject
        </Button>
        <Button variant="outline" onClick={() => doExport("/reconciliation/export", { only_diff: true }, "laporan-rekonsiliasi.xlsx")} className="border-taupe text-cocoa" data-testid="export-recon-btn">
          <Download className="w-4 h-4 mr-1.5" /> Selisih Rekonsiliasi
        </Button>
      </PageHeader>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Panel className="p-5">
          <h3 className="font-heading font-bold text-cocoa mb-4">Distribusi Hasil QC</h3>
          <ResponsiveContainer width="100%" height={280}>
            <BarChart data={qcData}>
              <XAxis dataKey="name" tick={{ fill: "#8A7970", fontSize: 12 }} />
              <YAxis tick={{ fill: "#8A7970", fontSize: 12 }} allowDecimals={false} />
              <Tooltip />
              <Bar dataKey="value" radius={[6, 6, 0, 0]}>
                {qcData.map((d, i) => <Cell key={i} fill={d.color} />)}
              </Bar>
            </BarChart>
          </ResponsiveContainer>
        </Panel>

        <Panel className="p-5">
          <h3 className="font-heading font-bold text-cocoa mb-4">Produk Paling Banyak Reject</h3>
          <div className="space-y-2">
            {(data?.top_reject || []).map((r) => (
              <div key={r.name} className="flex items-center justify-between py-2 border-b border-taupe/10 last:border-0">
                <span className="text-sm text-cocoa">{r.name}</span>
                <span className="text-sm font-bold text-status-reject">{r.qty}</span>
              </div>
            ))}
            {!data?.top_reject?.length && <div className="text-sm text-wmuted py-6 text-center">Belum ada data reject.</div>}
          </div>
        </Panel>
      </div>
    </div>
  );
}
